<template>
	<Layout header-class="header-left-align" nav-alignment="left" :topbar-style="2">
		<!-- Start Slider area -->
		<div class="slider-area slider-style-2 variation-2 height-450 bg_image"
				 :style="{'background-image': `url(${require(`@/assets/images/banner-ai.png`)})`}">
			<div class="container">
				<h2 class="w-600 title text-left color-white mb--0 banner-text">DeepSeek企業版</h2>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap sbg" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">DeepSeek企業版</h2>
				<div style="margin-top: 48px; ">
					<p style="font-size: 18px">
						提供企業級DeepSeek大模型解決方案，以全棧私有化部署為核心，深度融合行業特徵，攻克企業AI落地需要面對的數據安全閉環、信創全棧適配、場景精準賦能、成本極致優化等四大核心挑戰，依託"算力-模型-知識-應用"四維融合架構，實現從基礎大模型到行業智能體的全鏈路轉化，助力企業構建安全、專屬、高效的生成式AI生產力引擎。
					</p>
				</div>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">產品優勢</h2>
				<div class="product product-r">
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">安全可信的AI基礎設施</div>
									<div class="t2">
										全閉環數據治理：模型訓練與推理全程在企業內網完成，結合量子加密傳輸與SGX內存隔離技術，實現敏感數據"生產-處理-銷毀"全生命周期零外泄<br>
										異構硬件兼容：支持華為昇騰/凌久微GPU/寒武紀MLU等國產算力，提供容器化/K8s雙軌部署方案，單節點至超算集群靈活擴展
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">自主可控的信創技術棧</div>
									<div class="t2">
										全棧國產化適配：通過高性能/龍芯CPU+麒麟OS+達夢數據庫的端到端信創認證，集成國密SM4/SM9算法滿足等保3.0要求<br>
										性能深度優化：針對昇騰910B等國產芯片定制NPU指令集，推理速度提升3倍；支持FP8混合精度訓練，顯存佔用減少50%
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">智能業務賦能平台</div>
									<div class="t2">
										行業AI工廠：預置金融風控、醫療輔助診斷等25個場景工具包，支持低代碼拖拽式應用組裝，交付週期縮短70%<br>
										知識增強體系：融合企業知識圖譜與RAG技術，問答準確率提升至98%；智能體工作流引擎支持複雜業務流程自動化編排
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">極致成本控制體系</div>
										<div class="t2">
											動態資源調度：通過MoE稀疏激活+CPU/GPU混合負載技術，推理能耗降低40%，千億模型單卡即可部署<br>
											智能算力熔斷：基於Prometheus的異構算力融合平台，實現資源利用率提升60%，閒置算力自動釋放
										</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
					<div class="pic">
						<img src="@/assets/images/ds1.png" style="border-radius: 12px;">
					</div>
				</div>
			</div>
		</div>

		<Separator />

		<div class="rwt-advance-tab-area rn-section-gap" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">應用場景</h2>
				<div class="product">
					<div class="pic">
						<img src="@/assets/images/ds2.png" style="border-radius: 12px;">
					</div>
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">金融行業，智能風控與高效服務</div>
										<div class="t2">
											智能投顧與交易輔助：私有化部署的DeepSeek大模型支持金融市場智能對話交易，通過自然語言理解交易指令，自動生成交易策略，實時分析市場風險。<br>
											信貸風控與合規審計：風控助手整合企業信貸數據，自動生成風險評估報告、合規審查建議，並實時監控異常交易。<br>
											智能客服與客戶體驗升級：遠程銀行坐席助手基於私有知識庫提供精準問答，支持多輪業務辦理。
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">製造業，生產優化與智能運維</div>
										<div class="t2">
											預測性維護與設備管理：融合設備傳感器數據與工藝知識圖譜，實時預測機械故障。<br>
											智能質檢與工藝優化：工業視覺大模型本地化部署，自動識別產品缺陷（如表面劃痕、裝配錯誤），並反饋至生產系統調整參數。<br>
											供應鏈智能調度：私有化模型分析訂單、庫存、物流數據，動態優化排產計劃與供應商協同。
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">醫療健康，精準診療與高效管理</div>
									<div class="t2">
										臨床決策支持：淄博市衛健委部署的DeepSeek-R1醫療模型，結合患者病史、影像數據，生成診斷建議與用藥方案，並屏蔽非醫學交互。<br>
										智能病歷與科研輔助：自動結構化電子病歷，輔助科研人員挖掘疾病關聯性，生成研究假設。<br>
										疫情預警與公共衛生管理：私有化模型分析區域醫療數據，預測傳染病爆發趨勢，指導資源調配。
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">政府與公共服務，安全治理與便民服務</div>
									<div class="t2">
										政務智能問答與流程審批：政務雲部署大模型，實現政策諮詢自動解答、行政許可材料預審。<br>
										城市安全監控與應急響應：公安系統私有化模型實時解析監控視頻，自動識別異常行為，觸發告警。
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">企業內部管理，知識賦能與效率革命</div>
										<div class="t2">
											企業知識庫智能問答：私有化模型接入內部文檔（如產品手冊、技術規範），員工通過自然語言快速檢索信息。<br>
											智能辦公與流程自動化：自動生成會議紀要、合規報告，輔助代碼開發與測試用例編寫。
										</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
				</div>
			</div>
		</div>

	</Layout>
</template>

<script>
import Layout from '@/components/common/Layout'
import Separator from '@/components/elements/separator/Separator'
import Swiper from "swiper";
import "swiper/css/swiper.css";
export default {
	name: 'Solution1',
	components: {Separator, Layout},
	data() {
		return {

		}
	},
	mounted() {
		new Swiper(".swiper-container", {
			autoplay: true,
			delay: 2000,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				renderBullet: function (index, className) {
					return '<span class="' + className + '">' + (index + 1) + "</span>";
				},
			},
		});
	}
}
</script>
<style lang="scss" scoped>
.sbg {
	background-image: url("../../../assets/images/sbg.jpg");
}
.product {
	margin-top: 72px;
	display: flex;
	.pic {
		width: 40%;
		img {
			width: 100%;
		}
	}
	.txt {
		width: 60%;
		.eee {
			width: 90%;
			text-align: left;
			.t1 {
				font-size: 24px;
				font-weight: 600;
				color: #000;
			}
			.t2 {
				margin-top: 12px;
				color: #000;
			}
		}
	}
}
@media only screen and (max-width: 768px) {
	.product {
		flex-direction: column;
		gap: 20px;
		.pic {
			width: 100%;
		}
		.txt {
			width: 100%;
		}

		&.product-r {
			flex-direction: column-reverse;
		}
	}
}
.swiper-container {
	width: 100%;
	.swiper-wrapper {
		width: 100%;
	}
	.swiper-slide {
		width: 100%;
		text-align: center;
		font-size: 18px;
		background: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	:deep(.swiper-pagination) {
		bottom: 30px;
		position: unset;
	}

	:deep(.swiper-pagination-bullet) {
		width: 20px;
		height: 20px;
		text-align: center;
		line-height: 20px;
		font-size: 12px;
		color: #000;
		opacity: 1;
		background: rgba(0, 0, 0, 0.2);
	}

	:deep(.swiper-pagination-bullet-active){
		color: #fff;
		background: #007aff;
	}
}
.banner-text {
	text-shadow:
		0 0 2px black,
		0 0 2px black,
		0 0 2px black,
		0 0 2px black;
}
</style>
